/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const MODERNIZATION_ALLOWED_MESSAGE = (
    <FormattedMessage
        id='building_upgrade_tooltip.modernization_allowed_message'
        defaultMessage='Нажмите, чтобы модернизировать.'
    />
)

export const RESERVE_PRODUCTION_IN_PROGRESS = (
    <FormattedMessage
        id='building_upgrade_tooltip.reserve_production_in_progress'
        defaultMessage='Командующий и его заместители смогут модернизировать строение после завершения в нём текущей подготовки резервов.' // eslint-disable-line max-len
    />
)

export const UPGRADE_COMMAND_CENTER = (
    <FormattedMessage
        id='building_upgrade_tooltip.upgrade_command_center'
        defaultMessage='Командующий и его заместители смогут модернизировать строение после модернизации командного центра.' // eslint-disable-line max-len
    />
)



// WEBPACK FOOTER //
// ./containers/BuildingCard/components/UpgradeTooltip/constants.jsx